export const isBenignGlobalErrorMessage = (message?: string | null): boolean => {
  if (!message) return false;

  return (
    message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded')
  );
};
